import { useState } from "react";
import useMutateVendor from "./hooks/useMutateVendor";
import { VendorFormData } from "./components/edit-vendor-form/edit-vendor.schema";
import { useHistory } from "react-router-dom";
import BaseButton from "components/common/BaseButton";
import CreateVendorForm from "./components/create-vendor-form/CreateVendorForm";
import BaseModal from "../shared/components/BaseModal";
import { useIntl } from "react-intl";
import { usAdminAppRoutes } from "../../../route-definitions";
import EntityPageLayout from "../shared/components/EntityPageLayout";

const CreateVendor = () => {
  const history = useHistory();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const intl = useIntl();

  const {
    createVendor,
    createVendorLoading,
    createVendorSuccess,
    createVendorError,
  } = useMutateVendor({
    onCreateSuccess: () => {
      setModalIsOpen(true);
    },
    onCreateError: () => {
      setModalIsOpen(true);
    },
  });

  const onSubmit = (data: VendorFormData) => {
    createVendor(data);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    if (createVendorSuccess) {
      history.push(usAdminAppRoutes.vendors);
    }
  };

  return (
    <EntityPageLayout headerMessage="usAdmin.createVendor">
      <BaseModal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        footer={
          <BaseButton
            handleSubmit={handleCloseModal}
            text={intl.formatMessage({ id: "usAdmin.ok" })}
          />
        }
      >
        {createVendorSuccess && (
          <h2>
            {intl.formatMessage({ id: "usAdmin.vendorCreatedSuccessfully" })}
          </h2>
        )}
        {createVendorError && (
          <h2>{intl.formatMessage({ id: "usAdmin.vendorExists" })}</h2>
        )}
      </BaseModal>
      <CreateVendorForm
        onSubmit={onSubmit}
        isSubmitting={createVendorLoading}
      />
    </EntityPageLayout>
  );
};

export default CreateVendor;
